import Form from "react-bootstrap/Form";
import useFilter from "customHooks/useFilter";
import { useMap } from "context/mapContext";

function UnitsHistoryReportFilter() {
  const [map, dispatchMap] = useMap();

  const { unitsHistoryDomains, unitsHistoryFields, unitsHistoryTable } = map;

  const { methods, handleResetFilter, onSubmitOfEsri } = useFilter({
    domains: unitsHistoryDomains,
    fields: unitsHistoryFields,
    featureLayer: unitsHistoryTable,
    objName: "unitsHistory",
    reducerOrState: "reducer",
    queryFeaturesOptions: { orderByFields: ["created_date DESC"] },
    dispatch: dispatchMap,
  });
  const { register, handleSubmit } = methods;

  const onSubmit = (data) => {
    const tempData = { ...data };
    onSubmitOfEsri(tempData);
  };

  return (
    <form id="search" onSubmit={handleSubmit(onSubmit)}>
      <Form.Group className="input input-md" controlId="formBasicEmail">
        <Form.Label>Unit ID</Form.Label>
        <Form.Control
          {...register("Unit_Prod_ID")}
          autoComplete="false"
          type="text"
          placeholder="Search by Unit ID"
        />
      </Form.Group>
      <Form.Group className="input input-md" controlId="formBasicEmail">
        <Form.Label>Palette ID</Form.Label>
        <Form.Control
          {...register("Pallet_ID")}
          autoComplete="false"
          type="text"
          placeholder="Search by Palette ID"
        />
      </Form.Group>
      <div className="select">
        <Form.Label>Category</Form.Label>
        <Form.Select defaultValue="" {...register("Category")}>
          <option value="">All</option>
          {unitsHistoryDomains?.Category &&
            unitsHistoryDomains?.Category?.map((item) => (
              <option key={item.code} value={item.code}>
                {item.name}
              </option>
            ))}
        </Form.Select>
      </div>
      <div className="select">
        <Form.Label>Location</Form.Label>
        <Form.Select defaultValue="" {...register("Location")}>
          <option value="">All</option>
          {unitsHistoryDomains &&
            unitsHistoryDomains?.Location?.map((item) => (
              <option key={item.code} value={item.code}>
                {item.name}
              </option>
            ))}
        </Form.Select>
      </div>
      <div className="select">
        <Form.Label>Status</Form.Label>
        <Form.Select defaultValue="" {...register("Is_Installed")}>
          <option value="">All</option>
          {unitsHistoryDomains?.Is_Installed &&
            unitsHistoryDomains?.Is_Installed?.map((item) => (
              <option key={item.code} value={item.code}>
                {item.name}
              </option>
            ))}
        </Form.Select>
      </div>
      <Form.Group className="input input-md" controlId="created_date_from">
        <Form.Label>Date (From)</Form.Label>
        <Form.Control type="date" {...register("created_date_from")} />
      </Form.Group>
      <Form.Group className="input input-md" controlId="created_date_to">
        <Form.Label>Date (To)</Form.Label>
        <Form.Control type="date" {...register("created_date_to")} />
      </Form.Group>
      <div className="button-group">
        <button type="submit" form="search" className="btn btn--primary">
          Filter
        </button>
        <button
          onClick={() => {
            handleResetFilter();
          }}
          type="button"
          className="btn btn--primary"
        >
          Clear
        </button>
      </div>
    </form>
  );
}

export default UnitsHistoryReportFilter;
